import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  Card,
  Tag,
  Typography,
  Empty,
  Modal,
} from "antd";
import { MessageOutlined } from "@ant-design/icons";

const { Text } = Typography;

export const ProjectProcess = ({ rowData, mainProps }) => {
  const { lstGpp, onGetGppByGpId } = mainProps;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [descriptionContent, setDescriptionContent] = useState("");

  useEffect(() => {
    if (rowData.idGasProject) onGetGppByGpId(rowData.idGasProject);
  }, [rowData.idGasProject]);

  const showDescriptionModal = (desc) => {
    setDescriptionContent(desc || "توضیحی ثبت نشده است");
    setIsModalVisible(true);
  };

  const columns = [
    {
      title: "نام و نام خانوادگی",
      dataIndex: "fullName",
      key: "fullName",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "توضیحات کارشناس",
      key: "description",
      align: "center",
      render: (_, record) => (
        <Button
          type="link"
          icon={<MessageOutlined />}
          onClick={() => showDescriptionModal(record.description)}
        >
          نمایش نظر
        </Button>
      ),
    },
    {
      title: "تاریخ تخصیص",
      dataIndex: "solarDateDeliverEngineer",
      key: "solarDateDeliverEngineer",
      align: "center",
    },
    {
      title: "مرحله پرونده",
      key: "projectLevelName",
      render: (row) =>(
        <Tag color={row.inspectionStatusEnum === 3 || row.inspectionStatusEnum === 2 ? "red" : "green"}>
          {row.projectLevelName}
        </Tag>
      ),
      align: "center",
    },
    {
      title: "وضعیت",
      key: "inspectionStatusName",
      align: "center",
      render: (row) => (
        <Tag color={row.defect ? "red" : row.inspectionStatusEnum === 3 || row.inspectionStatusEnum === 2 ? "red" : "green"}>
          {row.defect
            ? `${row.inspectionStatusName} با نقص`
            : row.inspectionStatusName}
        </Tag>
      ),
    },
    {
      title: "نقص دارد",
      dataIndex: "defect",
      key: "defect",
      align: "center",
      render: (defect) => (
        <Tag color={defect ? "error" : "success"}>
          {defect ? "بله" : "خیر"}
        </Tag>
      ),
    },
    {
      title: "شماره موبایل",
      dataIndex: "cellPhone",
      key: "cellPhone",
      align: "center",
    },
  ];

  return (
    <>
      <Card
        title="فرآیندهای پروژه"
        variant={false}
        styles={{
          header: {
            borderBottom: "1px solid #f0f0f0",
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={lstGpp}
          rowKey="id"
          bordered
          size="middle"
          scroll={{ x: true }}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="نظر کارشناس ثبت نشده است"
              />
            ),
          }}
          pagination={{
            hideOnSinglePage: true,
            pageSize: 5,
            responsive: true,
          }}
        />
      </Card>

      <Modal
        title="توضیحات کارشناس"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionContent}</p>
      </Modal>
    </>
  );
};
